import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import axios from 'axios';
// import {isAuthenticated} from './auth/authenticate';
// if(isAuthenticated())
// {
//   axios.defaults.headers.post['Authorization'] = 'Bearer ' + isAuthenticated().data.token;//for POST requests

// }

axios.defaults.baseURL = 'https://nhathuocvantien.herokuapp.com/api';
// axios.defaults.headers.common['Authorization'] = token;//for all requests
axios.defaults.headers.post['Content-Type'] = 'application/json';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
